import { type IAdvancedRichText } from '@framework/engine/inputs/rich-text-advanced/IAdvancedRichText.ts';
import { type IconType } from '@framework/engine/schema/widgets/repository/advanced/buttons/icons/Icons.tsx';
import { type ButtonAlign } from '@framework/engine/schema/widgets/repository/advanced/buttons/types/ButtonEnums.ts';
import { type IGraphicWidget } from '@framework/engine/schema/widgets/repository/graphics/IGraphicWidget.ts';
import {
  type IBaseLayoutOptions,
  type WidgetType,
} from '@framework/engine/schema/widgets/Widget.ts';
import { type ButtonType } from 'antd/es/button';

export interface IDownloadWidgetLayout extends IBaseLayoutOptions {
  iconType?: IconType;
  buttonType?: ButtonType;
  buttonAlign?: ButtonAlign;
}

export const WidgetDownloadType = 'download' as WidgetType.Download;

/**
 * Interfaccia Download Widget
 */
export interface IDownloadWidget extends IGraphicWidget {
  id: string;
  type: WidgetType.Download;
  label?: IAdvancedRichText;
  layout?: IDownloadWidgetLayout;
  filePath?: string;
}
